/**
 * HTML 인앱메시지를 렌더링하기 위한 iframe과 그 wrapper element의 스타일을 관리합니다.
 * wrapper의 투명도를 제어함으로써, iframe 내부 콘텐츠가 준비되었을 때 가시화하는 역할을 합니다.
 *
 * 현재의 HTML 인앱 메시지 구현은 모달처럼 화면 전체를 점유하는 UI에 적합하지만,
 * 배너처럼 화면 일부만 차지하면서 나머지 영역의 페이지 인터랙션도 허용해야 하는 UI는 지원이 불가능합니다.
 * 2026.03.24 기준 현재 스펙으로 HTML 인앱 메시지를 지원하는 것으로 협의되었습니다.
 * @see https://dalbang.atlassian.net/wiki/spaces/DALBANG/pages/3367370757/In-App+Message+HTML+Unsupported+Features
 */
export class HtmlInAppMessageDOMStyle {
  static beforeLoadedWrapperStyles() {
    return {
      position: "fixed",
      top: "0",
      left: "0",
      bottom: "0",
      right: "0",
      zIndex: "9999",
      opacity: "0",
      pointerEvents: "none",
      transition: "opacity 0.3s ease-in-out"
    }
  }

  static afterLoadedWrapperStyles() {
    return {
      opacity: "1"
    }
  }

  static beforeLoadedIframeStyles() {
    return {
      width: "100%",
      height: "100%",
      border: "none",
      pointerEvents: "none"
    }
  }

  static afterLoadedIframeStyles() {
    return {
      pointerEvents: "auto"
    }
  }
}
